export const PlayingCard = ({ card, index, discarded, selectable, onToggle }) => (
  <button
    type="button"
    className={`poker-card ${card?.color === "red" ? "is-red" : ""} ${discarded ? "is-discarded" : ""}`}
    onClick={() => onToggle(index)}
    disabled={!selectable}
    aria-pressed={discarded}
    aria-label={`${card?.rank || "Card"} of ${card?.suit_name || "unknown"}${discarded ? ", selected to discard" : ", kept"}`}
    data-testid={`member-card-${index}`}
  >
    <span className="poker-card-corner"><b>{card?.rank}</b><i>{card?.suit}</i></span>
    <span className="poker-card-suit">{card?.suit}</span>
    <span className="poker-card-corner poker-card-corner-bottom"><b>{card?.rank}</b><i>{card?.suit}</i></span>
    <span className="poker-held-flag" data-testid={`member-card-status-${index}`}>{discarded ? "DISCARD" : "KEEP"}</span>
  </button>
);